import { useField } from "formik";
import TagsInput from "react-tagsinput";
import { Form, FormSelectProps } from "react-bootstrap";
import "react-tagsinput/react-tagsinput.css";
import "../../assets/css/tagInput.scss";
import { useState } from "react";
import { useIntl } from "react-intl";

type SimpleFormTagsInputProps = FormSelectProps & {
    label?: string;
    values?: Array<string>;
    name: string;
    cssClass?: string[];
    addEmpty?: boolean;
    disabled?: boolean;
    tagPlaceholder?: string;
    sorted?: boolean;

    [key: string]: any;
};
const SimpleFormTagsInput: React.FC<SimpleFormTagsInputProps> = (props) => {
    const { label, name, disabled = false, tagPlaceholder = "add tag", sorted = true } = props;
    const { formatMessage } = useIntl();
    const [formikProps, meta, helpers] = useField(name);
    const [value, setValue] = useState((sorted ? meta.value?.sort() : meta.value) || []);

    return (
        <div className="mb-2">
            {label && <Form.Label>{label}</Form.Label>}
            <TagsInput
                {...formikProps}
                inputProps={{ placeholder: tagPlaceholder }}
                onlyUnique
                disabled={disabled}
                value={value}
                onChange={(tags) => {
                    helpers.setValue(tags);
                    setValue(tags);
                }}
            />
            {meta.error && meta.touched && (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">
                            {meta.error.includes("error.")
                                ? formatMessage({ id: meta.error })
                                : meta.error}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SimpleFormTagsInput;
